import { List, Record } from 'immutable';
import handleAction from '../common/utils/handle-action.js';
import simpleReducer from '../common/utils/simple-reducer.js';
import { apiKeyCreationModalClosed, createApiKey, getApiKeys } from './actions.js';

export const ApiKeysState = Record({
  items: List([]),
  loading: false,
  loaded: false,
  error: null,
  creating: false,
  apiKey: ''
});

const initialState = new ApiKeysState();

const handleClearApiKey = (state) => {
  return state.set('apiKey', '');
};

const createApiKeysHandlers = {
  PENDING(state) {
    return state.set('creating', true);
  },
  FULFILLED(state, { payload }) {
    return state.merge({
      creating: false,
      apiKey: payload.apiKey.apiKey
    });
  },
  REJECTED(state) {
    return state.set('creating', false);
  }
};

const getApiKeysHandlers = {
  PENDING(state) {
    return state.merge({
      loading: true,
      loaded: false,
      error: null
    });
  },
  FULFILLED(state, { payload }) {
    return state.merge({
      items: List(payload.apiKeys),
      loading: false,
      loaded: true,
      error: null
    });
  },
  REJECTED(state, { payload }) {
    return state.merge({
      loading: false,
      error: payload.message
    });
  }
};

export default simpleReducer(initialState, {
  ...handleAction(getApiKeys.PREFIX, getApiKeysHandlers),
  ...handleAction(createApiKey.PREFIX, createApiKeysHandlers),
  [apiKeyCreationModalClosed]: handleClearApiKey
});
